// Class: openfl.utils._internal.format.amf3.AMF3Array

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../../../hxClasses_stub").default;
var $hxEnums = require("./../../../../../hxEnums_stub").default;

// Constructor

var AMF3Array = function(initA,initExtra) {
	this.a = initA;
	this.extra = initExtra;
}

// Meta

AMF3Array.__name__ = "openfl.utils._internal.format.amf3.AMF3Array";
AMF3Array.__isInterface__ = false;
AMF3Array.prototype = {
	
};
AMF3Array.prototype.__class__ = AMF3Array.prototype.constructor = $hxClasses["openfl.utils._internal.format.amf3.AMF3Array"] = AMF3Array;

// Init



// Statics


AMF3Array.__meta__ = { fields : { extra : { optional : null}}}

// Export

exports.default = AMF3Array;